export const generateTimeDescriptiveId = (): string => {
    const now = new Date();
    return now.toISOString()
        .replace(/[:.]/g, '-')  // replace : and . with -
        .replace('T', '---')    // replace T with ---
        .replace('Z', '');      // remove Z
}; 